import type { SVGProps } from 'react';

/** Figma `metric-resonance.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MetricResonanceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M2.45508 7.36257V12.2717H5.72781L9.81871 15.5444V4.08984L5.72781 7.36257H2.45508Z"
        fill="#FB2337"
      />
      <path
        id="Vector_2"
        d="M12.2734 6.95277C13.0916 7.77095 13.0916 11.0437 12.2734 12.68M14.728 5.31641C16.3643 7.36186 16.3643 12.271 14.728 14.3164"
        stroke="#FB2337"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
